import {useState,useEffect} from "react";
import { useOutletContext } from "react-router-dom";
import { Link } from "react-router-dom";

const GameGuideSlideUi = ({gameSvcCd,gameMainPageInfo}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const [gameMainPageInfoState,setGameMainPageInfoState] = useState<any>();

    useEffect(()=>{
        setGameMainPageInfoState(gameMainPageInfo);
    },[gameMainPageInfo])

    const guideList = gameMainPageInfoState?.gintrLst || [];
    const mainGuideCard = guideList[0];
    const subGuideCards = guideList.slice(1, 5);

    return(
        <>
        <div className="swiper-container">
            <div className="ctntLstTitlWrap mainPageCtntTitlWrap">
                <p>GAME PREVIEW</p>
            </div>
            <div className="gameGuideStaticLayout">
                {mainGuideCard && (
                    <div className="gameGuideStaticMainCard gameGuideSlideLi">
                        <Link to={mainGuideCard.cardUrl} onClick={(e) => e.preventDefault()} className="mainGuideImgFrame">
                            <div className="mainGuideVideoFrame gameGuideStaticFrame frameCornerAll">
                                <div className="mainGuideMediaClip">
                                    <img src={mainGuideCard.cardImgUrl} alt="" className="cardImg"/>
                                </div>
                                <span className="mainGuideFrameOverlay" aria-hidden="true">
                                    <svg viewBox="0 0 100 100" preserveAspectRatio="none" focusable="false" aria-hidden="true">
                                        <polygon className="outerFrame" points="4,0 96,0 100,4 100,96 96,100 4,100 0,96 0,4" />
                                    </svg>
                                </span>
                            </div>
                        </Link>
                    </div>
                )}

                {subGuideCards.length > 0 && (
                    <div className="gameGuideStaticSubCards">
                        {subGuideCards.map((key:any, index:number)=>(
                            <div className="gameGuideStaticSubCard gameGuideSlideLi" key={key.cardImgUrl || key.cardUrl}>
                                <Link to={key.cardUrl} onClick={(e) => e.preventDefault()} className="mainGuideImgFrame">
                                    <div className={`mainGuideVideoFrame gameGuideStaticFrame ${
                                        index === 0
                                            ? "frameCornerTL"
                                            : index === 1
                                                ? "frameCornerTR"
                                                : index === 2
                                                    ? "frameCornerBL"
                                                    : "frameCornerBR"
                                    }`}>
                                        <div className="mainGuideMediaClip">
                                            <img src={key.cardImgUrl} alt="" className="cardImg"/>
                                        </div>
                                        <span className="mainGuideFrameOverlay" aria-hidden="true">
                                            <svg viewBox="0 0 100 100" preserveAspectRatio="none" focusable="false" aria-hidden="true">
                                                <polygon className="outerFrame" points="4,0 96,0 100,4 100,96 96,100 4,100 0,96 0,4" />
                                            </svg>
                                        </span>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                )}
                <img src={process.env.PUBLIC_URL + "/images/Mainpage/previewbrick.png"} alt="" className="mainGuideCardImg"/>
            </div>
        </div>
        </>
    )
}

export default GameGuideSlideUi;